import { axios, buildAuthConfig, getApiUrl, withHeaders } from '@/services/apiClient';
const participants = '/participants/';
export default {
  config() {
    return buildAuthConfig(
      this.store &&
        this.store.state &&
        this.store.state.loginInfo &&
        this.store.state.loginInfo.accessToken
    );
  },
  store: {},
  getAuctionDetail(id, invitation_token) {
    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
      if (this.config()) {
        return axios.get(
          this.store.state.apiUrl + 'auctions/' + id + '?nocache=' + new Date().getTime(),
          this.config()
        );
      } else {
        return axios.get(
          this.store.state.apiUrl +
            'auctions/' +
            id +
            '/?invitation_token=' +
            invitation_token +
            '&nocache=' +
            new Date().getTime()
        );
      }
    } else {
      if (this.config()) {
        return axios.get(this.store.state.apiUrl + 'auctions/' + id, this.config());
      } else {
        return axios.get(
          this.store.state.apiUrl + 'auctions/' + id + '/?invitation_token=' + invitation_token
        );
      }
    }
  },
  patchAuctionDetail(id, jsonToSend) {
    return axios.patch(this.store.state.apiUrl + 'auctions/' + id + '/', jsonToSend, this.config());
  },
  getParticipantBid(id, hash) {
    return axios.get(
      this.store.state.apiUrl + 'auctions/' + id + '/bids/' + hash + '/?hash=' + hash,
      this.config()
    );
  },
  activateAuction(auctionId) {
    return axios.post(
      this.store.state.apiUrl + 'auctions/' + auctionId + '/plan/',
      {},
      this.config()
    );
  },
  cancelAuction(auctionId) {
    return axios.post(
      this.store.state.apiUrl + 'auctions/' + auctionId + '/cancel/',
      {},
      this.config()
    );
  },
  submitAuctionBid(auctionId, jsonToSend, hash) {
    return axios.post(
      this.store.state.apiUrl + 'auctions/' + auctionId + '/bids/?hash=' + hash,
      jsonToSend
    );
  },
  createBider(auctionId, jsonToSend) {
    return axios.post(
      this.store.state.apiUrl + 'auctions/' + auctionId + '/bids/',
      jsonToSend,
      this.config()
    );
  },
  createBidderWithInvitation(auctionId, jsonToSend, invitationToken) {
    return axios.post(
      this.store.state.apiUrl +
        'auctions/' +
        auctionId +
        '/bids/?invitation_token=' +
        invitationToken,
      jsonToSend
    );
  },
  updateAuctionBid(auctionId, bidID, jsonToSend) {
    return axios.patch(
      this.store.state.apiUrl + 'auctions/' + auctionId + '/bids/' + bidID + '/',
      jsonToSend,
      this.config()
    );
  },
  deleteAuctionBid(auctionId, bidID) {
    return axios.delete(
      this.store.state.apiUrl + 'auctions/' + auctionId + '/bids/' + bidID + '/',
      this.config()
    );
  },
  createAuction(jsonToSend) {
    return axios.post(
      getApiUrl(this.store.state.apiUrl) + 'auctions/create/',
      jsonToSend,
      this.config()
    );
  },
  removeAuction(auctionID) {
    return axios.delete(this.store.state.apiUrl + 'auctions/' + auctionID, this.config());
  },
  editAuction(auctionID, params) {
    const header = this.config();
    return axios.patch(
      this.store.state.apiUrl + 'auctions/' + auctionID + '/',
      params,
      withHeaders(header)
    );
  },
  editBidNameEmail(auctionID, bidId, params) {
    const header = this.config();
    return axios.patch(
      this.store.state.apiUrl + 'auctions/' + auctionID + '/bids/' + bidId + '/',
      params,
      withHeaders(header)
    );
  },
  filterAuction(page, page_size, filter) {
    const header = this.config() || {};
    if (!Number.isInteger(page)) {
      page = 1;
    }
    if (!Number.isInteger(page_size)) {
      page_size = 20;
    }
    let params = {
      page: page ? page : 1,
      page_size: page_size ? page_size : 20,
      order_by: 'title',
    };
    if (filter) {
      for (let item in filter) {
        if (filter[item]) {
          params[item] = filter[item];
        }
      }
    }
    return axios.get(this.store.state.apiUrl + 'auctions/', {
      params,
      headers: header.headers || {},
    });
  },
  getParticipants(auctionID) {
    return axios.get(this.store.state.apiUrl + 'auctions/' + auctionID + participants);
  },
  addParticipant(auctionID, jsonToSend) {
    return axios.post(
      this.store.state.apiUrl + 'auctions/' + auctionID + participants,
      jsonToSend,
      this.config()
    );
  },
  deleteParticipant(auctionID, participantID) {
    return axios.delete(
      this.store.state.apiUrl + 'auctions/' + auctionID + participants + participantID + '/',
      this.config()
    );
  },
  changeParticipant(auctionID, participantID, jsonToSend) {
    return axios.patch(
      this.store.state.apiUrl + 'auctions/' + auctionID + participants + participantID + '/',
      jsonToSend,
      this.config()
    );
  },
};
